// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"1eb05f47","990":"5fc27a67"}[chunkId] + ".chunk.css";
};